import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import AppModal from "./AppModal";
import { api } from "../utils/api";
import { stripJwtFromStorage } from "../utils/authSession";

const SESSION_TIMEOUT_EVENT = "session-timeout-event";

const clearSessionLocal = () => {
  stripJwtFromStorage();
  localStorage.removeItem("userId");
  localStorage.removeItem("orgId");
  localStorage.removeItem("accessModules");
  localStorage.removeItem("role");
  localStorage.removeItem("portalTenantView");
  localStorage.removeItem("portalTenantOrgId");
  localStorage.removeItem("plan");
  localStorage.removeItem("plan_status");
};

const SessionTimeoutModal = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [message, setMessage] = useState("Your session has expired. Please log in again.");
  const navigate = useNavigate();

  const endSession = async () => {
    const userId = localStorage.getItem("userId");
    try {
      if (userId) {
        await api("/logout", {
          method: "POST",
          body: JSON.stringify({ userId }),
        });
      }
    } catch {
      /* ignore */
    }
    clearSessionLocal();
    setIsOpen(false);
    navigate("/nyafaz-salon", { replace: true });
  };

  useEffect(() => {
    const handleSessionTimeout = (event) => {
      const nextMessage = String(
        event?.detail?.message || "Your session has expired. Please log in again."
      );
      setMessage(nextMessage);
      setIsOpen(true);
    };

    window.addEventListener(SESSION_TIMEOUT_EVENT, handleSessionTimeout);

    return () => {
      window.removeEventListener(SESSION_TIMEOUT_EVENT, handleSessionTimeout);
    };
  }, []);

  useEffect(() => {
    if (!isOpen) return;

    const timer = window.setTimeout(() => {
      endSession();
    }, 2200);

    return () => window.clearTimeout(timer);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isOpen, navigate]);

  return (
    <AppModal
      open={isOpen}
      onClose={endSession}
      title="Session Timed Out"
      size="md"
      zIndex={99998}
      footer={(
        <button
          type="button"
          onClick={endSession}
          className="app-modal-btn-primary rounded-xl px-4 py-2 text-sm font-semibold transition"
        >
          Go to Login
        </button>
      )}
    >
      <p className="text-sm font-medium text-slate-700">{message}</p>
    </AppModal>
  );
};

export default SessionTimeoutModal;
